import { render, staticRenderFns } from "./Adicion.vue?vue&type=template&id=4cfd2a8f&"
import script from "./Adicion.vue?vue&type=script&lang=js&"
export * from "./Adicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports